import { __awaiter } from "tslib";
/**
 * 组件使用场景：撮合成交
 * */
import React, { Component } from 'react';
import { BrokeredDeal } from '@/components/index';
import ReactDOM from 'react-dom';
import store, { dispatch } from '@@/store';
import { Provider } from '@souche-f2e/muji';
class BrokeredDealPack extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            selectData: {},
        };
        this.cancel = this.cancel.bind(this);
        this.handleOK = this.handleOK.bind(this);
    }
    cancel() {
        this.setState({
            show: false,
            selectData: {},
        });
        this.callback = undefined;
    }
    handleOK() {
        this.callback && this.callback();
        this.cancel();
    }
    show(selectData, callback) {
        this.setState({
            show: true,
            selectData,
        });
        callback && (this.callback = callback);
        this.getOtherFee(selectData);
    }
    getOtherFee(data) {
        const { commissionDeal, brokerageDeal } = data;
        if (commissionDeal || brokerageDeal) {
            return;
        }
        const { priorityOfferYuan } = data;
        priorityOfferYuan && dispatch.carState.getDefaultCommissionBrokerage({
            carType: data.carTypeId,
            priorityOffer: data.priorityOfferYuan.split(',').join(''),
            callback: (res) => {
                this.setState({
                    selectData: Object.assign(Object.assign({}, data), { commissionDeal: res.commissionY, brokerageDeal: res.brokerageY }),
                });
            },
        });
    }
    render() {
        const { show, selectData } = this.state;
        const { commissionDeal, brokerageDeal } = selectData;
        return (<BrokeredDeal visible={show} onOk={this.handleOK} onCancel={this.cancel} dealPrice={selectData.priorityOfferYuan ? selectData.priorityOfferYuan.split(',').join('') : ''} servicePrice={commissionDeal} commission={brokerageDeal} sellerCode={selectData.sellerCode} goodsId={selectData.goodsId} roundId={selectData.roundId} auctionId={selectData.auctionId}/>);
    }
}
BrokeredDealPack.defaultProps = {};
const BrokeredDealComponent = BrokeredDealPack;
let componentRef = '';
const createAbortiveAuction = () => {
    const div = document.createElement('div');
    document.body.appendChild(div);
    componentRef = React.createRef();
    const component = (<Provider store={store}>
      <BrokeredDealComponent ref={componentRef}/>
    </Provider>);
    ReactDOM.render(component, div);
};
export default function toBrokeredDeal(selectData, callback) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!componentRef) {
            yield createAbortiveAuction();
        }
        console.log(componentRef);
        componentRef.current.show(selectData, callback);
    });
}
